import React, { useEffect, useRef } from 'react';

const QRCodeSection = () => {
    const qrCodeRef = useRef(null);

    useEffect(() => {
        // Generate QR code using qr-server API
        const generateQRCode = () => {
            if (qrCodeRef.current) {
                const currentURL = window.location.origin + '/guest-book';
                const qrCodeURL = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(currentURL)}`;
                qrCodeRef.current.src = qrCodeURL;
            }
        };

        generateQRCode();
    }, []);

    const copyURL = () => {
        const guestBookURL = window.location.origin + '/guest-book';
        navigator.clipboard.writeText(guestBookURL).then(() => {
            alert('Link copiato negli appunti! 📋');
        }).catch(() => {
            alert('Impossibile copiare il link. Prova manualmente: ' + guestBookURL);
        });
    };

    return (
        <div className="qr-code-section">
            <div className="content-container">
                <div className="qr-code-content">
                    <div className="qr-code-header">
                        <h3 className="qr-title font uppercase">
                            📱 Accesso Rapido al Libro degli Ospiti
                        </h3>
                        <p className="qr-subtitle font-detail">
                            Condividi questo QR code con i tuoi invitati per un accesso immediato! 
                            Perfetto da stampare sui biglietti o mostrare durante l'aperitivo ✨
                        </p>
                    </div>
                    
                    <div className="qr-code-container">
                        <div className="qr-code-card">
                            <div className="qr-code-wrapper">
                                <img 
                                    ref={qrCodeRef}
                                    alt="QR Code per Guest Book"
                                    className="qr-code-image"
                                />
                                <div className="qr-code-label">
                                    <span className="font bold">Scansiona per lasciare</span>
                                    <span className="font bold">un messaggio speciale!</span>
                                </div>
                            </div>
                            
                            <div className="qr-actions">
                                <button 
                                    onClick={copyURL}
                                    className="copy-link-btn font"
                                >
                                    🔗 Copia Link
                                </button>
                                
                                <button 
                                    onClick={() => window.print()}
                                    className="print-qr-btn font"
                                >
                                    🖨️ Stampa QR Code
                                </button>
                            </div>
                        </div>
                        
                        <div className="qr-instructions">
                            <h4 className="instructions-title font bold">Come utilizzare:</h4>
                            <ul className="instructions-list font-detail">
                                <li>📱 <strong>Per gli invitati:</strong> Scansiona il QR code con la fotocamera del telefono</li>
                                <li>🖨️ <strong>Per te:</strong> Stampa questo QR code e mettilo sui tavoli o biglietti</li>
                                <li>📤 <strong>Condivisione:</strong> Copia il link e invialo via WhatsApp o social</li>
                                <li>🎉 <strong>Durante la festa:</strong> Mostra il QR code sugli schermi dell'evento</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QRCodeSection; 
